import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00bfa5",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2196f3",
    },
    info: {
      main: "#1976d2",
    },
    error: {
      main: "#f44336",
    },
    warning: {
      main: "#ff9800",
    },
    success: {
      main: "#4caf50",
    },
  },
  secondary: {
    main: "#e91e63",
  },
  info: {
    main: "#1976d2",
  },
  error: {
    main: "#f44336",
  },
  warning: {
    main: "#ff9800",
  },
  success: {
    main: "#4caf50",
  },
  text: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#bdbdbd",
    },
  },
});

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  ,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
